import { render } from "./PublicIPAddresses.vue?vue&type=template&id=a97bf8e2&scoped=true"
import script from "./PublicIPAddresses.vue?vue&type=script&lang=js"
export * from "./PublicIPAddresses.vue?vue&type=script&lang=js"

import "./PublicIPAddresses.vue?vue&type=style&index=0&id=a97bf8e2&scoped=true&lang=scss"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97bf8e2"]])

export default __exports__